
import {
  Component, Vue, Prop, Watch
} from 'vue-property-decorator';
import { uploadFile } from '@/services/http';

interface VoucherSubmitPayload {
  voucherName: string;
  voucherUrl: string;
  orderNo: string;
  complete: (success: boolean) => void;
}

@Component({ name: 'TransferDialog' })
export default class TransferDialog extends Vue {
  @Prop({ required: true }) visible!: boolean;

  @Prop({ default: 1 }) status!: number; // 1: 待提交凭证, 2: 核对中, 3: 已完成

  @Prop({ default: '' }) orderNo!: string;

  @Prop({ default: '0.00' }) amount!: string;

  @Prop({ type: String, default: '' }) accountName!: string;

  @Prop({ type: String, default: '' }) accountNo!: string;

  @Prop({ type: String, default: '' }) bankName!: string;

  @Prop({ type: String, default: '' }) payerName!: string; // 提交凭证时填写的付款方名称

  @Prop({ default: '' }) deadline!: string;

  @Prop({ default: '' }) voucherImage!: string;

  dialogVisible: boolean = false;

  voucherName: string = '';

  uploadedUrl: string = '';

  previewImage: string = '';

  isEditing: boolean = false;

  isSubmitting: boolean = false;

  @Watch('visible')
  onVisibleChange(val: boolean) {
    this.dialogVisible = val;
    if (val) {
      this.resetVoucherForm();
      this.isEditing = false;
      this.isSubmitting = false;
    }
  }

  get canSubmit(): boolean {
    return !!this.voucherName.trim() && !!this.uploadedUrl;
  }

  handleClose() {
    this.isEditing = false;
    this.isSubmitting = false;
    this.$emit('update:visible', false);
    this.$emit('close');
  }

  resetVoucherForm() {
    this.voucherName = this.payerName;
    this.uploadedUrl = this.voucherImage;
    this.previewImage = this.voucherImage;
  }

  startEditing() {
    if (this.status !== 2) return;
    this.resetVoucherForm();
    this.isEditing = true;
  }

  cancelEditing() {
    if (this.isSubmitting) return;
    this.resetVoucherForm();
    this.isEditing = false;
  }

  copyInfo() {
    const info = `金额: ${this.amount} 元
户名: ${this.accountName}
账号: ${this.accountNo}
开户行: ${this.bankName}`;

    const textarea = document.createElement('textarea');
    textarea.value = info;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);

    this.$message.success('收款信息已复制');
  }

  triggerUpload() {
    (this.$refs.fileInput as HTMLInputElement).click();
  }

  async handleFileChange(event: Event) {
    const target = event.target as HTMLInputElement;
    const [file] = target.files || [];
    if (file) {
      this.previewImage = URL.createObjectURL(file);
      const form = new FormData();
      form.append('fileData', file);
      form.append('type', '11');
      const res: any = await uploadFile(form);
      if (res.data.code === 100 && res.data.data && res.data.data[0]) {
        this.uploadedUrl = res.data.data[0].sourceUrl;
        this.previewImage = this.uploadedUrl;
      } else {
        this.uploadedUrl = '';
        this.previewImage = '';
      }
      target.value = '';
    }
  }

  submitVoucher() {
    if (this.isSubmitting) return;
    if (!this.canSubmit) {
      this.$message.warning('请填写账户名并上传凭证图片');
      return;
    }

    this.isSubmitting = true;
    const payload: VoucherSubmitPayload = {
      voucherName: this.voucherName,
      voucherUrl: this.uploadedUrl,
      orderNo: this.orderNo,
      complete: (success: boolean) => {
        this.isSubmitting = false;
        if (success) this.isEditing = false;
      }
    };
    this.$emit('submit', payload);
  }
}
